import React from 'react';
import { Button, Card } from '@material-ui/core';

type Props = {
  page: number;
  setPage: (page: number, pageEntries: number) => void;
  pageIndex: number;
  totalPages: number;
  pageEntries: number;
};

export const PaginationButtons: React.FC<Props> = ({
  page,
  setPage,
  pageIndex = 1,
  totalPages,
  pageEntries = 10,
}) => (
  <span className="flex justify-end mr-20 py-5">
    <select
      value={pageEntries}
      onChange={(e) => setPage(1, Number(e.target.value))}
      className="
    mr-3 h-10 w-20
    rounded-md border border-gray-300
    bg-white text-center
    focus:outline-none focus:ring-2 focus:ring-secondary
  "
    >
      <option value={10}>10</option>
      <option value={15}>15</option>
      <option value={20}>20</option>
      <option value={25}>25</option>
    </select>
    <Button
      className="PaginationButtons"
      disabled={totalPages <= 1 || page === 1}
      onClick={() => setPage(page - 1, pageEntries)}
    >
      Prev Page
    </Button>
    <Button
      className="PaginationButtons"
      disabled={totalPages <= 1 || page >= totalPages}
      onClick={() => setPage(page + 1, pageEntries)}
    >
      Next Page
    </Button>
    <Card className="cursor-default mr-3 bg-secondary bg-opacity-80 text-white hover:bg-secondary hover:bg-opacity-80 pt-2 px-1 font-sans">
      Page: {totalPages === 0 ? 0 : pageIndex}/{totalPages}
    </Card>
  </span>
);
